export default __webpack_public_path__ + "static/media/eight.a6df9c26.jpg";